/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetMultipleExperimentModel,
  IGetMultipleExperimentRequest,
  IMappers,
  IGetMultipleExperimentResponse,
  IGetMultipleExperimentResponseError,
  TGetMultipleExperimentResponse,
} from './types';

const defaultConfig: TGetMultipleExperimentModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'ab-use',
  pathApi: '/v1/get-multiple-experiment/',
  hostType: 'api',
} as TGetMultipleExperimentModel;

function createGetMultipleExperimentModel(parameters: IGetMultipleExperimentRequest): TGetMultipleExperimentModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetMultipleExperimentOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetMultipleExperimentRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetMultipleExperiment<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetMultipleExperimentOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetMultipleExperimentResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetMultipleExperimentModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetMultipleExperimentResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetMultipleExperimentResponseError);
    }
  }

  return { response, statusCode } as TGetMultipleExperimentResponse;
}

export { defaultConfig, createGetMultipleExperimentModel, fetchGetMultipleExperiment };
